import { render } from "./Castle.vue?vue&type=template&id=523f3463&scoped=true"
import script from "./Castle.vue?vue&type=script&lang=js"
export * from "./Castle.vue?vue&type=script&lang=js"

import "./Castle.vue?vue&type=style&index=0&id=523f3463&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523f3463"]])

export default __exports__